(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.announcementBarSection = document.querySelector('.announcement-bar-section');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1049px)').addEventListener('change', this.setHeaderHeight.bind(this));

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      if (this.announcementBarSection) {
        this.announcementBarSection.classList.add('shopify-section-header-hidden');
      }
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      if (this.announcementBarSection) {
        this.announcementBarSection.classList.remove('shopify-section-header-hidden');
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

      if (this.announcementBarSection) {
        this.announcementBarSection.classList.remove(
          'shopify-section-header-hidden',
          'shopify-section-header-sticky',
          'animate'
        );
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const $ticker = document.querySelectorAll('.announcement-bar__message');

  if ($ticker) {
    // Observe visibility changes of ticker to update 'aria-hidden'
    const observer1 = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const tabIndexValue = !entry.isIntersecting ? '-1' : '0';
          entry.target.setAttribute('aria-hidden', !entry.isIntersecting);
          const anchor = entry.target.querySelector('a');
          anchor?.setAttribute('tabindex', tabIndexValue);
        });
      },
      { threshold: 0.1 }
    );

    $ticker.forEach((wrapper) => {
      observer1.observe(wrapper);
    });
  }

  const scrollingMessages = document.querySelector('.scrolling-messages');
  const pauseButton = scrollingMessages?.querySelector('.announcement-bar__pause-btn');
  const track = scrollingMessages?.querySelector('.announcement-bar__track');

  if (scrollingMessages && pauseButton && track) {
    let isPaused = false;
    let isInteractionPaused = false; // hover/focus pause (temporary)

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const nudgeResumeIfNeeded = () => {
      // Nudge without resetting animation progress (no jump)
      // Helps some browsers after tab switching / backgrounding.
      track.style.animationPlayState = 'paused';
      // eslint-disable-next-line no-unused-expressions
      track.offsetHeight; // reflow
      track.style.animationPlayState = 'running';
    };

    const applyState = ({ nudge = false } = {}) => {
      const shouldPause = prefersReducedMotion.matches || isPaused || isInteractionPaused;

      // Icon/UI state reflects ONLY the sticky paused state (button)
      scrollingMessages.classList.toggle('is-paused', isPaused);
      pauseButton.classList.toggle('slideshow__autoplay--paused', isPaused);

      pauseButton.setAttribute('aria-pressed', String(isPaused));
      pauseButton.setAttribute('aria-label', isPaused ? 'Play announcements' : 'Pause announcements');

      track.style.animationPlayState = shouldPause ? 'paused' : 'running';

      if (!shouldPause && nudge) {
        nudgeResumeIfNeeded();
      }
    };

    pauseButton.addEventListener('click', () => {
      isPaused = !isPaused;

      applyState({ nudge: !isPaused });
    });

    scrollingMessages.addEventListener('mouseenter', () => {
      isInteractionPaused = true;
      applyState();
    });

    scrollingMessages.addEventListener('mouseleave', () => {
      isInteractionPaused = false;
      applyState({ nudge: !isPaused });
    });

    scrollingMessages.addEventListener('focusin', () => {
      isInteractionPaused = true;
      applyState();
    });

    scrollingMessages.addEventListener('focusout', () => {
      isInteractionPaused = false;
      applyState({ nudge: !isPaused });
    });

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) applyState({ nudge: !isPaused });
    });

    window.addEventListener('focus', () => applyState({ nudge: !isPaused }));
    prefersReducedMotion.addEventListener('change', () => applyState());

    applyState();
  }

  } catch(e) { console.error(e); }
})();
})();
